import { Link } from 'react-router-dom';
import { getFeaturedVideos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function FeaturedVideos() {
  const featured = getFeaturedVideos();

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 animate-fade-in">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              精选蘑菇成品人视频
            </h2>
            <p className="text-sm text-foreground-500">
              编辑精选的高质量蘑菇种植视频教程
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            更多视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {featured.slice(0, 8).map((video, idx) => (
            <div
              key={video.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <VideoCard video={video} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}